.discord-embed-footer {
	-webkit-box-align: center;
	align-items: center;
	color: #dcddde;
	display: flex;
	font-size: 12px;
	line-height: 16px;
	font-weight: 500;
	grid-column: 1/3;
	grid-row: auto/auto;
	margin-top: 8px;
}

.discord-embed-footer .discord-footer-image {
	border-radius: 50%;
	flex-shrink: 0;
	height: 20px;
	margin-right: 8px;
	width: 20px;
}

.discord-embed-footer .discord-footer-separator {
	color: #dcddde;
	font-weight: 500;
	display: inline-block;
	margin: 0 4px;
}

.discord-light-theme .discord-embed-footer .discord-footer-separator {
	color: #e4e4e4;
}
